/* eslint-disable no-param-reassign */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '..';

interface AuthState {
  token: string | null;
}

const initialState: AuthState = {
  token: null,
};
const authSlice = createSlice({
  initialState,
  name: 'auth',
  reducers: {
    setToken: (state, { payload }: PayloadAction<string | null | undefined>) => {
      if (payload === undefined) {
        return;
      }

      state.token = payload ?? null;
    },
  },
});

export const selectAuthToken = (state: RootState) => state.auth.token;

export const { setToken } = authSlice.actions;

export default authSlice;
